import { ApiProperty } from "@nestjs/swagger";

export class PoItemsDetails {
    @ApiProperty()
    itemCategory:number;
    @ApiProperty()
    itemSubCategoryId:number;
    @ApiProperty()
    item:number;
    @ApiProperty()
    size:number;
    @ApiProperty()
    quantity:number;
    @ApiProperty()
    unitPrice:number;
    @ApiProperty()
    tax:number;
    @ApiProperty()
    taxAmount:number;
    @ApiProperty()
    discountPercentage:number;
    @ApiProperty()
    discountAmount:number;
    @ApiProperty()
    transportation:number;
    @ApiProperty()
    Amount:number;
    @ApiProperty()
    bomItemId:number;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    purchaseOrderId?:number;
    @ApiProperty()
    purchaseOrderItemId?:number;
    @ApiProperty()
    updatedUser?:string;
    @ApiProperty()
    createdUser?:string;
    @ApiProperty()
    fromPo?:boolean;
    @ApiProperty()
    isActive?: boolean;
}